import {Api} from "./api.gen";
import React from "react";
import {AuthStore} from "../stores/AuthStore";

export const createApi = (auth: AuthStore) => new Api<undefined>({
  baseUrl: window.location.port === '3000' ? 'http://localhost:8000' : undefined,
  baseApiParams: {
    secure: true,
    headers: {
      'Content-Type': 'application/json',
    }
  },
  securityWorker: async () => {
    await auth.refresh();
    return {
      headers: auth.getAuthHeaders(),
    };
  }
});

export const ApiContext = React.createContext<Api<undefined> | undefined>(undefined);